<template>
  <panel :title="$tc('tournament.change_history')" :max-height="500" collapsable>
    <el-table
      :data="data"
      :row-class-name="getRowClassName"
      style="width: 100%"
      >
      <el-table-column v-if="false" type="expand">
        <template slot-scope="props">
          <div v-html="getItemHistory(props.row)" />
        </template>
      </el-table-column>
      <el-table-column
        :label="$tc('general.change')">
        <template slot-scope="scope">
          <b>{{ scope.row.user ? scope.row.user.name : $t('general.deleted_user') }}</b>
          {{ $tc(`changes.${scope.row.type}`) }}
          <b>{{ getItemName(scope.row) }}</b>
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('general.date')"
        width="200px"
        align="right">
        <template slot-scope="scope">
          {{ scope.row.createdAt | date('DD.MM.YYYY HH:mm') }}
        </template>
      </el-table-column>
    </el-table>
  </panel>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    },

    tournament: {
      type: Object,
      required: true
    }
  },

  methods: {
    getItemHistory (item) {
      // if (['OFFICIAL_DELETE', 'REFEREE_DELETE', 'COACH_DELETE', 'COMPETITOR_DELETE', 'TEAM_DELETE'].includes(item.type)) {
      //   return this.$t('tournament.no_additional_info')
      // }

      // if (['REGISTER_COMPETITOR', 'REGISTER_TEAM', 'REGISTER_COACH', 'REGISTER_REFEREE', 'REGISTER_OFFICIAL'].includes(item.type)) {
      // }

      if (['TEAM_UPDATE', 'COMPETITOR_UPDATE'].includes(item.type)) {
        return 'Nema dodatnih informacija'
      }

      return this.$t('tournament.no_additional_info')
    },
    getRowClassName ({ row }) {
      return new Date(this.tournament.endDate) < new Date(row.createdAt) ? 'after-end-date' : ''
    },

    getItemName (change) {
      if (['REGISTER_COMPETITOR', 'COMPETITOR_UPDATE', 'COMPETITOR_DELETE'].includes(change.type)) return this.getName(change.item)
      if (['REGISTER_COACH', 'COACH_DELETE'].includes(change.type)) return this.getName(change.item)
      if (['REGISTER_REFEREE', 'REFEREE_DELETE'].includes(change.type)) return this.getName(change.item)
      if (['REGISTER_OFFICIAL', 'OFFICIAL_DELETE'].includes(change.type)) return this.getName(change.item)
      if (['REGISTER_TEAM', 'TEAM_UPDATE', 'TEAM_DELETE'].includes(change.type)) return change.item?.map(i => this.getName(i)).join(', ')
    },

    getName (member) {
      if (!member) return ''
      return `${member.firstName} ${member.lastName}`
    }
  }
}
</script>

<style scoped>
.el-table >>> .after-end-date {
  background-color: #ffeded;
}
</style>
